import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { CanvassStatus } from "../../models/canvass-status.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";

let AppointmentSettings = {
    selector: "vcAppointmentSettings",
    templateUrl:
        "/angular/components/planner/appointment-settings.component.html",
    bindings: {},
    controller: class AppointmentSettingsController {
        private $scope: any;
        private dataProvider: CanvassStatusDataProvider;
        private dialog: DialogUtils;

        public activeCampaign: Campaign;
        public isLeaderView: boolean;
        public canvassStatuses: CanvassStatus[];
        public savingStatuses: boolean = false;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            CanvassStatusDataProvider: CanvassStatusDataProvider
        ) {
            this.$scope = $scope;
            this.dataProvider = CanvassStatusDataProvider;
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.dataProvider
                .walkCanvassStatuses()
                .then((statuses: CanvassStatus[]) => {
                    this.canvassStatuses = statuses;
                });
        }
        selectStatus(status: CanvassStatus): void {
            if (status.workflow && status.workflow.appointment) {
                status.workflow.appointment = !status.workflow.appointment;
            } else {
                status.workflow = { appointment: true };
            }
        }

        ok(): void {
            if (!this.savingStatuses) {
                this.savingStatuses = true;
                this.dataProvider.setStatuses(this.canvassStatuses);

                let data = this.canvassStatuses;
                this.dataProvider.workflows(data).then(() => {
                    this.savingStatuses = false;
                    this.dialog.hide();
                });
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("planner")
    .component(AppointmentSettings.selector, AppointmentSettings);
